import { render, staticRenderFns } from "./KOSPI.vue?vue&type=template&id=727c4eca"
import script from "./KOSPI.vue?vue&type=script&lang=js"
export * from "./KOSPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports